import { oids } from "@/configs/Settings";

/**
 * Prefixo exclusivo da presença de teleconsultoria.
 * O chat legado usa `doc-` e `pat-` (CPF do paciente). Reutilizar esses IDs
 * faria o chat receber `unavailable-id` ou conectar no peer errado.
 */
const PRESENCE_PREFIX = "tc-";

/**
 * PeerJS só aceita letras, números, hífen e underscore.
 * O teto de 60 caracteres é o mesmo limite usado no chat.
 */
function sanitizePeerId(id: string): string {
  return id.replace(/[^a-zA-Z0-9\-_]/g, "").slice(0, 60);
}

/** ID de presença a partir do CPF do profissional (`user.username`). */
export function teleconsultoriaPresencePeerId(
  cpf: string,
): string | undefined {
  const digits = cpf.replace(/\D/g, "");
  if (!digits) return undefined;

  const peerId = sanitizePeerId(`${PRESENCE_PREFIX}${digits}`);
  if (!peerId.startsWith(PRESENCE_PREFIX)) return undefined;
  if (peerId.length <= PRESENCE_PREFIX.length) return undefined;
  return peerId;
}

/**
 * ID de presença a partir da reference FHIR
 * `Practitioner/${oids.cpf}-{cpf}`.
 */
export function presencePeerIdFromPractitionerRef(
  reference: string,
): string | undefined {
  const marker = `Practitioner/${oids.cpf}-`;
  if (!reference.startsWith(marker)) return undefined;
  return teleconsultoriaPresencePeerId(reference.slice(marker.length));
}
